<template>
  <div>
    <form>
      <!-- ///responsável -->
      <div class="">
        <div class="row">
          <!-- <div
          class="col-md-3"
           v-if="data.id"
        >
          <form-group-image
            :url="url+'formpayment/icon/'+data.id"
            :value="data.ImageURL"
            img-type="square"
          />
        </div> -->

          <div class="col-md-3">
            <fg-input
              class="clean"
              type="date"
              label="Data final"
              placeholder="prazo"
              v-model="data.date"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              class="clean"
              type="time"
              label="Hora final"
              placeholder="prazo"
              v-model="data.time"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-6">
            <fg-input
              class="clean"
              type="text"
              label="Valor"
              placeholder="Valor"
              v-on:input="format"
              v-model="data.formattedInitialOffer"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-12">
            <fg-select
              :options="carList"
              v-model="data.CarId"
              :selected="data.CarId"
              label="Carro"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import moment from "moment";
import formGroupImage from "src/components/UIComponents/Inputs/formGroupImage.vue";
import { NAMES } from "../../../config";

export default {
  name: "auction-form",
  components: {
    formGroupImage,
  },

  props: {
    data: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    event: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: NAMES.fullUrl,
    },
  },

  computed: {
    ...mapState({
      carList: ({ car }) =>
        car.list.map((obj) => {
          return {
            name: obj.code + " - " + obj.name,
            value: obj.id,
          };
        }),
    }),
  },

  methods: {
    ...mapActions(["getCarList"]),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },

    formatDate(date) {
      return moment
        .utc(date)
        .utcOffset(-180)
        .format("D/M/YYYY H:mm:ss");
    },

    format: function(sValue) {
      this.data.formattedInitialOffer = parseInt(
        ("" + sValue).onlyNumber()
      ).int2Money();

      this.data.initialOffer = this.data.formattedInitialOffer
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },
  },

  created() {
    this.getCarList();

    this.$on("execute", () => {
      this.$parent.$emit(this.event, this.data);
    });

  },
  data() {
    return {
      localReadonly: false,
    };
  },
};
</script>
<style scoped lang="scss">
label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/AuctionForm.vue